import { EventEmitter, Injectable, Output } from '@angular/core';
import { StorageService, StorageType } from 'gast-common-ng';
import { PageDto } from 'gast-portal-ng/lib/shared/dto/page-dto';

import { CourseListElementDto } from '../dto/course-list-element-dto';
import { StorageKeys } from '../constants/storage-keys';
import { ShoppingCartModel } from 'src/app/course/course-shopping-cart/model/shopping-cart-model';


@Injectable()
export class ShoppingCartService {

    @Output() courseFound: EventEmitter<PageDto<CourseListElementDto>> = new EventEmitter();

    constructor(
        private storageService: StorageService
    ) { }

    public getShoppingCartModel(): ShoppingCartModel {
        return this.storageService.getItem(StorageKeys.SHOPPING_CART_MODEL, StorageType.Session) as ShoppingCartModel;
    }

}
